import {useSystemStore} from "@/stores/system/SystemStore";

export default function resetFooterCounter ({next}:any){
    const systemStore = useSystemStore();

    systemStore.currentItems = 0;
    systemStore.allItems = 0;

    return next();
}
